import { Components, Theme } from '@mui/material';

export const textFieldStyles: Components<Theme>['MuiTextField'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      '& .MuiOutlinedInput-root': {
        backgroundColor: 'white',
        '& .MuiOutlinedInput-input': {
          padding: '16px 20px'
        },
        '& fieldset': {
          color: theme.palette.primary.main,
          borderColor: theme.palette.customGrey.dark,
          borderRadius: 0,
          padding: 0
        },
        '&.Mui-focused': {
          '& .MuiOutlinedInput-notchedOutline': {
            border: theme.palette.border.large.primary.main
          }
        },
        '&.Mui-error': {
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.palette.error.main,
            borderWidth: '1px'
          }
        }
      }
    })
  }
};
